import { css, Theme } from "@emotion/react";

export const FavouriteGamePageStyle = {
  self: css`
    border: 1px solid #ddd;
    border-radius: 3px;
  `,

  head: ({ colors }: Theme) => css`
    width: 100%;
    height: 51px;
    color: ${colors.white};
    background-color: ${colors.orange[200]};
    padding: 10px 15px;
    border-bottom: 1px solid #ddd;
    border-radius: 3px 3px 0px 0px;
    display: flex;
    align-items: center;
  `,

  title: ({ colors }: Theme) => css`
    color: ${colors.white};
    font-size: 21px;
    flex: 1;
    text-align: center;
  `,

  backIcon: ({ colors }: Theme) => css`
    font-size: 18px;
    fill: ${colors.white};
    cursor: pointer;
  `,

  body: css`
    width: 100%;
    min-height: 400px;
    border-radius: 0px 0px 3px 3px;
    padding: 15px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
  `,
  bodyEmpty: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    width: 100%;
    min-height: 400px;
    padding: 15px;
    gap: 10px;

    img {
      object-fit: contain;
      height: 83px;
    }

    h3 {
      font-size: 24px;
      margin-top: 20px;
      font-family: inherit;
      font-weight: 500;
      line-height: 1.1;
      color: #bfbfbf;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    }

    span {
      color: #bfbfbf;
      font-size: 14px;
      text-align: center;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      line-height: 1.42857143;
    }
  `,
};
